import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from '@stvgroup/stv-ui-components'
import PlayerMenu from './index'

/**
 * Renders the player navigation for both desktop and mobile without waiting for client layout.
 * Desktop version is always inline and hidden via CSS below the xl breakpoint;
 * mobile version lives inside a Modal and uses the same component instance.
 */

const PlayerMenuContainer = ({
  open,
  onClose,
  id,
  ...rest
}) => (
  <>
    <PlayerMenu
      {...rest}
      menuOpen={false}
      menuActive={open}
      isDesktop
      closeMenu={onClose}
    />
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <PlayerMenu
        {...rest}
        id={id}
        closeMenu={onClose}
        menuOpen={open}
        menuActive={open}
        isDesktop={false}
      />
    </Modal>
  </>
)

PlayerMenuContainer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  // Pass through props for PlayerMenu
  id: PropTypes.string,
  groupToken: PropTypes.string.isRequired,
  closeSearch: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  hostname: PropTypes.string.isRequired,
  activeItem: PropTypes.string,
  isSearchMenuActive: PropTypes.bool,
  renderCTVBanner: PropTypes.bool,
  accountMenuActive: PropTypes.bool,
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    signedIn: PropTypes.bool,
    vipOptIn: PropTypes.bool,
    currentlySubscribed: PropTypes.bool,
  }),
}

PlayerMenuContainer.defaultProps = {
  open: false,
  id: '',
  items: [],
  activeItem: '',
  isSearchMenuActive: false,
  renderCTVBanner: false,
  accountMenuActive: false,
  user: null,
  closeSearch: () => {},
}

export default PlayerMenuContainer
